import React from 'react';

import type { SlideBlock } from '@swf/generated/cms/types/Carousel';

import CarouselSlider from '../CarouselSlider';

import DefaultCarouselItem from './DefaultCarouselItem';

interface Props {
  autoRotate: boolean;
  slides: SlideBlock[];
  slideSpeed: number;
}

const minNumberOfSlides = 3;

const DefaultCarousel: React.FC<Props> = ({ autoRotate, slides, slideSpeed }) => {
  if (slides.length < minNumberOfSlides) {
    return null;
  }

  return (
    <CarouselSlider
      autoRotate={autoRotate}
      className="center"
      responsive={[
        {
          breakpoint: 725,
          settings: {
            slidesToShow: 1
          }
        }
      ]}
      slideSpeed={slideSpeed}
    >
      {slides.map(({ slide }, key) => (
        <DefaultCarouselItem key={key} slide={slide} />
      ))}
      {slides.length === minNumberOfSlides &&
        slides.map(({ slide }, key) => <DefaultCarouselItem key={key} slide={slide} />)}
    </CarouselSlider>
  );
};

export default DefaultCarousel;
